import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=a8a5a89e"
import script from "./SideBarItem.vue?vue&type=script&lang=js"
export * from "./SideBarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports